import { createSelector } from 'reselect';

const clientSelector = state => state.client;

export const getClient = createSelector(
    clientSelector,
    client => client,
);
